import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CancelTicketOwnershipRequest } from 'src/app/model/api/api-request/ticketownership/cancel-ticket-ownership-request';
import { GetTicketOwnershipsRequest } from 'src/app/model/api/api-request/ticketownership/get-ticket-ownerships-request';
import { UpdateTicketOwnershipRequest } from 'src/app/model/api/api-request/ticketownership/update-ticket-ownership-request';
import { UnsubscribeNewsletterRequest } from 'src/app/model/api/api-request/unsubscribe-newsletter-request';
import { MyTicketResponse } from 'src/app/model/interfaces/my-ticket-response';
import { AppConfigService } from 'src/app/services/app-config.service';
import { MyTicketRequest } from '../../model/api/api-request/my-ticket-request';
import { ApiClient } from '../api-client/api-client';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionRepository
{
    private readonly apiClient: ApiClient;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }

    // Most likely obsolete - 18.06.2024 commented it out to test.
    // If obsolete remove SubscriptionRequest also.
    // public getSubscriptions(): Observable<TicketSubscription[]>
    // {
    //     const webapiBasepath = this.environment.config['webapibasepath'];
    //     const request = new SubscriptionRequest(webapiBasepath);
    //     return this.apiClient.get(request);
    // }

    public getMyTickets(): Observable<any>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new MyTicketRequest(webapiBasepath);
        return this.apiClient.get(request);
    }

    public getTicketOwnerships(): Observable<any>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new GetTicketOwnershipsRequest(webapiBasepath);
        return this.apiClient.get(request);
    }

    public updateTicketOwnershipPaymentMethod(playerId: number, ticketNumber: number, ticketLetter: string, paymentMethodId: any): Observable<MyTicketResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new UpdateTicketOwnershipRequest(playerId, ticketNumber, ticketLetter, paymentMethodId, webapiBasepath);
        return this.apiClient.put(request);
    }

    public cancelTicketOwnership(playerId: number, ticketNumber: number, ticketLetter: string): Observable<MyTicketResponse>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new CancelTicketOwnershipRequest(playerId, ticketNumber, ticketLetter, webapiBasepath);
        return this.apiClient.delete(request);
    }

    public unsubscribeNewsletter(email: string): Observable<boolean>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new UnsubscribeNewsletterRequest(email, webapiBasepath);
        return this.apiClient.post(request);
    }
}
